import React, { Fragment, useEffect } from 'react';
import { useParams } from "react-router-dom";
import stylistData from '../../data/stylists.json';
import Instagram from '../../images/instagram.png';

const BOOKING_MAP = {
  "Habit 1 (Gilbert)": {
    id: "2fb0d8b1-5dc2-4864-aefb-5ef8b8d22e90",
    label: "Habit 1 (Arizona)"
  },
  "Habit 2 (Gilbert)": {
    id: "2fb0d8b1-5dc2-4864-aefb-5ef8b8d22e90",
    label: "Habit 2 (Arizona)"
  },
  "Habit 3 (Orange County)": {
    id: "2fb0d8b1-5dc2-4864-aefb-5ef8b8d22e90",
    label: "Habit 3 (California)"
  }
};

const SingleStylist = () => {
  const { slug } = useParams();
  const stylistPage = stylistData.find(e => e.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!stylistPage) return <p>Stylist not found.</p>;

  const workDays = stylistPage.work_days.map(d => (
    <p key={d} className="day">{d}</p>
  ));
  const skills = stylistPage.specialties.map(s => (
    <p key={s} className="skills">{s}</p>
  ));

  // build booking links
  const bookings = (stylistPage.salon || [])
    .map(salonName => BOOKING_MAP[salonName])
    .filter(Boolean);

  return (
    <Fragment>
      <header className="stylist-area">
        <div className="container">
          <div className="stylist-header-cnt">
            <div className="single-stylist-item">
              <img
                className="stylists-image"
                src={stylistPage.stylist_image}
                alt={`${stylistPage.first_name} ${stylistPage.last_name}`}
              />
              <div className="stylist-skills">
                <p className="single-stylist-job">Skills</p>
                <div className="stylist-skill-list">{skills}</div>
              </div>
            </div>
            <div className="stylist-information">
              <div className="stylist-name-container">
                <h6 className="single-stylist-name">
                  {stylistPage.first_name} {stylistPage.last_name}
                </h6>
                <a
                  className="instagram"
                  rel="noopener noreferrer"
                  target="_blank"
                  href={`https://instagram.com/${stylistPage.instagram}`}
                >
                  <img className="instagram-stylist" src={Instagram} alt="Instagram" />
                </a>
              </div>

              <p className="single-stylist-job">Hair Stylist</p>
              {stylistPage.fun_fact && (
                <p className="single-stylist-fact">{stylistPage.fun_fact}</p>
              )}

              <div className="stylist-meta">
                <p className="stylist-experience">
                  {stylistPage.years_of_exp} years
                  <p className="stylist-category">Experience</p>
                </p>
                <div className="stylist-work">
                  <div className="stylist-days">{workDays}</div>
                  <p className="stylist-category">Days I Work</p>

                  {/* Booking buttons */}
                  <div className="booking-buttons">
                    {bookings.length > 0 ? (
                      bookings.map(({ id, label }) => (
                        <a
                          key={label}
                          className="book-appointment"
                          href={`https://dashboard.boulevard.io/booking/businesses/${id}/widget#/visit-type`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Book Appointment – {label}
                        </a>
                      ))
                    ) : (
                      <a className="book-appointment" href="/">
                        Book Appointment
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </Fragment>
  );
};

export default SingleStylist;
